import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Discover from '../../../common/redux/actions/DiscoverActions';
import { ILegendDatum } from '../../charts/viz-legend';
import { head, isEmpty } from 'lodash';
import * as uuid from 'uuid';
import { useVizOptionSelector } from '../../../common/redux/selectors/viz-selector.hook';
import { VIZ_OPTION_IDS } from '../../../common';

export const useColorSettings = (vizId: string, legendData: ILegendDatum[]) => {
  const dispatch = useDispatch();
  const legendGroupData = useVizOptionSelector({
    discoveryId: vizId,
    option: VIZ_OPTION_IDS.legendGroupMetadata,
    defaultValue: [],
  });

  const isAddColorGroupDisabled = useMemo(
    () => legendData.length === 0,
    [legendData],
  );
  const addColorGroup = useCallback(() => {
    dispatch(
      Discover.addVizLegendGroupData(vizId, {
        id: uuid.v4(),
        info: { label: '' },
        shape: head(legendData).shape,
        label: '',
        fields: [],
      }),
    );
  }, [dispatch, legendData, vizId]);

  const resetColors = useCallback(() => {
    if (!isEmpty(legendGroupData)) {
      dispatch(Discover.removeVizLegendGroupData(vizId));
    }
    dispatch(Discover.updateCustomColors(vizId, null));
  }, [dispatch, legendGroupData, vizId]);

  return {
    addColorGroup,
    resetColors,
    isAddColorGroupDisabled,
    legendGroupData,
  };
};
